import { Direction, useSetRTL } from '@ms/yammer-web-core-ui/dist/util/useSetRTL';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

export interface AppDocumentLanguageProps {
  readonly lang: string;
  readonly dir: Direction;
}

/**
 * Component that updates the language and text direction of the `<html>` tag.
 *
 * It shouldn't output anything visible!
 */
const AppDocumentLanguage: FC<AppDocumentLanguageProps> = ({ lang, dir }) => {
  useSetRTL(dir);

  return (
    <Helmet defaultTitle="Yammer" titleTemplate="Yammer - %s" defer={false}>
      <html lang={lang} dir={dir} />
    </Helmet>
  );
};

export default AppDocumentLanguage;
